import React, { useEffect } from 'react';

// Deep-navy pill toast with an optional Undo action. Auto-dismisses.
// The legacy BucketManager Toast has no action button, hence this new one.
export default function UndoToast({ toast, onUndo, onDismiss }) {
  useEffect(() => {
    if (!toast) return undefined;
    const ms = toast.type === 'error' ? 4000 : 6000;
    const t = setTimeout(onDismiss, ms);
    return () => clearTimeout(t);
  }, [toast, onDismiss]);

  if (!toast) return null;

  return (
    <div className={`pbnew-toast ${toast.type || ''}`} role="status">
      <span>{toast.message}</span>
      {toast.canUndo && (
        <button type="button" className="pbnew-toast-undo" onClick={onUndo}>
          Undo
        </button>
      )}
    </div>
  );
}
